// extracted by mini-css-extract-plugin
export default {"shakeAnimation":"RightBarButtonsPanel_shakeAnimation__cYEkO","shake":"RightBarButtonsPanel_shake__lwk0J"};